module.exports = __webpack_public_path__ + "img/Get-inspired.7a333b90.png";